// removed by extract-text-webpack-plugin
module.exports = {"cwShellTopNavLogo":"CwShellTopNavLogo-cwShellTopNavLogo","cwShellTopNavLogoImage":"CwShellTopNavLogo-cwShellTopNavLogoImage"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwshelltopnav/cwshelltopnavlogo/CwShellTopNavLogo.scss
// module id = 390
// module chunks = 0